import { Component } from 'react';
import { AceService } from '../services';

class Auth extends Component {
  state = {
    isVisible: false,
  };

  async componentDidMount() {
    const { access_token, id_token } = (await AceService.getTokens()) || {};

    if (!access_token || !id_token) {
      this.setState(state => ({
        ...state,
        isVisible: true,
      }));

      return;
    }

    window.location.replace(process.env.REACT_APP_MS_PLATFORM_ENDPOINT);
  }
  render() {
    return this.state.isVisible ? this.props.children : null;
  }
}

export default Auth;



// WEBPACK FOOTER //
// /app/apps/ms/src/providers/Auth.js